// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"3932c47f","748":"3eb466c3","882":"a081a60d"}[chunkId] + ".chunk.js";
};